// Bootstrap JS
// @devnote comment this line if you plan to
// use the CDN version of boostrap js
import 'bootstrap';

import { watchScroll } from './lib/scroll';
const { watchLazyVideos } = require('./lib/lazy-video');
import { silenceModalsOnDismiss } from './lib/video';
import { inInViewAnimations } from './lib/animate';
import Glide from '@glidejs/glide';

const timeStart = window.performance.now();

document.addEventListener('DOMContentLoaded', () => {

	watchScroll();

	silenceModalsOnDismiss();

	watchLazyVideos();

	inInViewAnimations();

	const timeEnd = window.performance.now();

	console.info(
		`Execution time: ${timeEnd - timeStart}ms after DOMContentLoaded.`
	);

});

